import { Routes } from '@/api/Routes';
import { http } from '@/common/utils/HttpServices';

export interface FilterRapport{
    page?: number;
    sort?: string;
    chantierIds?: number[];
    adresseProjetId?: number[];
    groupeId?: number[];
    sousGroupeId?: number[];
    equipementId?: number[];
    phaseId?: number[];
    dateDebut?: string;
    dateFin?: string;
    isPreventif: boolean;
    nomZip?: string;
    isForModal?: boolean;
    size?: number;
}

export interface RapportToDownload{
    interventionIds?: number[];
    chantierIds?: number[];
    nomZip?: string;
}


class RapportService {
    public async getRapports(params: FilterRapport): Promise<any>{
        return http.get(Routes.RapportRoutes.GetRapport(), {params});
    }
    public async getRapportPDF(params: RapportToDownload): Promise<any>{
        return http.get(Routes.RapportRoutes.GetRapportPDF(), {params, responseType: 'arraybuffer'});
    }

    public async getAllRapportPDF(params: FilterRapport): Promise<any>{
        return http.get(Routes.RapportRoutes.GetAllRapportPDF(), {params, responseType: 'arraybuffer'});
    }
}

export default new RapportService();
